import {type MouseEventHandler} from 'react';
import type {FoldersAndBookmarks, BookmarkFolder} from 'types';
import AdminBookmarksFolderView from './AdminBookmarksFolderView';
import AdminBookmarksRootView from './AdminBookmarksRootView';
import AdminBookmarksCardListSkeleton from './AdminBookmarksCardListSkeleton';

type AdminBookmarksCardListProps = {
  foldersAndUnfoldedBookmarks: FoldersAndBookmarks;
  selectedFolder: BookmarkFolder | null;
  handleBack: MouseEventHandler;
  createFolderClickHandler: Function;
  loading: boolean;
}

const AdminBookmarksCardList = ({ loading, foldersAndUnfoldedBookmarks, selectedFolder, handleBack, createFolderClickHandler } : AdminBookmarksCardListProps) => {

  if (loading) return <AdminBookmarksCardListSkeleton />;

  if (selectedFolder) return (
    <AdminBookmarksFolderView
      folder={selectedFolder}
      handleBack={handleBack}
    />
  );

  return (
    <AdminBookmarksRootView
      foldersAndUnfoldedBookmarks={foldersAndUnfoldedBookmarks}
      createFolderClickHandler={createFolderClickHandler}
    />
  );
}

export default AdminBookmarksCardList;